import api from './api';

const store = (idProctor, data) =>
  api.post(`/api/v2/berita_acara/proctor/${idProctor}`, data);

export { store };
